import React, { useEffect, useState } from "react";
// import "./myaddress.css";
// import "./Address/address.css";
import DefaultLayout from "../../layout/defaultLayout";
// import { useTranslation } from 'react-i18next'
import Brudcrumb from "../../components/brudcrumb/brudcrumb";
import { BsChevronDown } from "react-icons/bs";
import { Toggle } from "rsuite";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { get_towns } from "../UserSystem/functions";
import { SelectPicker } from "rsuite";
// import EditMap from './EditMAp/EditMap';
import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL } from "../../CONSTS";
import EditMap from "../MyAddresses/EditMAp/EditMap";
import { Spinner } from "reactstrap";
import { Select } from "@mui/material";
import { MenuItem } from "@mui/material/node";
const EditLocation = () => {
  // console.log(oldData,'dds')
  /* { oldData, handlechange, towns_2 } */
  const location=useLocation();
  const navigate=useNavigate()
  const {oldData}=location.state
  const accessToken = localStorage.getItem("accessToken");
  const [towns, setTowns] = useState(false);
  const language = useSelector((state) => state.language.lang);
  const options = {
    headers: {
      "Accept-Language": language,
    },
  };
  const data = JSON.parse(accessToken);
  const [allolddata, setallolddata] = useState({
    address: oldData.address,
    name: oldData.name,
    city: oldData.city,
    state: oldData.state,
    is_default: oldData.is_default,
    late: oldData.late,
    lang: oldData.lang,
    map_location: oldData.map_location,
  });

  const eqdata = () => {
    let myobj = {
      address: oldData.address,
      name: oldData.name,
      // city:oldData.city,
      state: oldData.state,
      is_default: oldData.is_default,
    };
    // console.log(myobj);
    setallolddata({
      address: oldData.address,
      name: oldData.name,
      city: '',
      state: oldData.state,
      is_default: oldData.is_default,
    });
  };
  const [editLoading,setEditLoading]=useState(false)
  useEffect(() => {
    setallolddata({
      address: oldData.address,
      name: oldData.name,
      city: oldData.city,
      state: oldData.state,
      is_default: oldData.is_default,
      late: oldData.late,
      lang: oldData.lang,
      map_location: oldData.map_location,
    });
  }, []);
  const [getTowns, setTownsName] = useState(false);

  const getTownsFunc=()=>{
    const options = {
      headers: {
        "Accept-Language": language,
      },
    };
    get_towns({ options }).then((res) => {
      setTowns(res);
      // console.log(res)
      let mycity = [];
      mycity = res.filter((item) => item.id == oldData?.city.id);
      setTownsName([
        ...res.map((item) => ({
          id: item?.id,
          name: item?.name,
        })),
      ]);
      setallolddata({ ...allolddata, city: mycity[0]?.id });
    });
  }
  useEffect(() => {
    getTownsFunc()
  }, [language]);
  const handleupdate = () => {
    setEditLoading(true)
    const formdata = new FormData();
    formdata.append("id", oldData.id);
    formdata.append("name", allolddata.name);
    formdata.append("address", allolddata.address);
    formdata.append("city", allolddata.city);
    formdata.append("state", allolddata.state);
    formdata.append("late", locationName?.latlng?.lat);
    formdata.append("lang", locationName?.latlng?.lng);
    formdata.append("is_default", allolddata.is_default == true ? 1 : 0);
    formdata.append("map_location", locationName.map_location);
    formdata.forEach((value, key) => {
      // console.log(`${key}: ${value}`);
    });

    axios
      .post(
        `${BASE_URL}api/web/v1/product/update-address?access-token=${data?.access_token}`,
        formdata,
        options
      )
      .then((res) => {
        // console.log(res.data.data);
        if (res?.data?.data[0]?.status == 0) {
          toast.error(res?.data?.data[0]?.message);
        } else if (res?.data?.data[0]?.status == 1) {
          toast.success(res?.data?.data[0]?.message);
          navigate("/myaddresses",{replace:true})
          // handleupdate()
          // window.location.reload();
          // window.location.reload();
        } else {
          toast.error(language == 'ar' ? "حدث خطأ ما" : "something went wrong");
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(language == 'ar' ? "حدث خطأ ما" : "something went wrong");
      }).finally(()=>{
        setEditLoading(false)
      })
  };
  // console.log("allolddata", allolddata);
  const [locationName, setLocationName] = useState({
    map_location: allolddata?.map_location,
    latlng: {
      lat: parseFloat(allolddata?.late),
      lng: parseFloat(allolddata?.lang),
    },
  });
  // const [towns, setTowns] = useState(false);
  useEffect(() => {
    const options = {
      headers: {
        "Accept-Language": language,
      },
    };
    get_towns({ options }).then((res) => {
      setTowns(res);
    });
    // setOpenEdit(false)
  }, [language]);

  return (
    <DefaultLayout
      children={
        <>
          <Brudcrumb
            title={language === "ar" ? "تعديل العنوان" : "Edit The Address"}
          />
          <div className="add_location_form">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleupdate();
        }}
      >
        <div>
          <label htmlFor="loc">
            {language === "ar" ? "العنوان" : "Address"}
          </label>
          <input
            onChange={(e) => {
              setallolddata({ ...allolddata, address: e.target.value });
            }}
            value={allolddata.address}
            id="loc"
            type="text"
            placeholder={language === "ar" ? "العنوان" : "Address"}
            name="address"
          />
        </div>
        <div>
          <label htmlFor="loc">
            {language === "ar" ? "عنوان العمل" : "Work Address"}{" "}
          </label>
          <input
            onChange={(e) => {
              setallolddata({ ...allolddata, name: e.target.value });
            }}
            value={allolddata.name}
            id="loc"
            type="text"
            placeholder={language === "ar" ? "عنوان العمل" : "Work Address"}
            name="name"
          />
        </div>
        {towns && towns.length ? (
          <div style={{ minHeight: '50px' }}>
            <label htmlFor="city">
              {language === "ar" ? "المدينه" : "City"}
            </label>
            <div style={{ marginBottom:'20px' }} className="city_div">
            <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Age"
                      // value={locdata?.city_name} // Initialize with an empty string
                      onChange={(e) => {
                        setallolddata({
                          ...allolddata,
                          city: e?.value ? e?.value : e,
                        });
                      }}
                      name="city"
                    >
                      {/* {console.log(towns)} */}
                      {towns && towns.length
                        ? towns
                            ?.map((out_item) => {
                              return {
                                id: out_item?.id,
                                value: out_item.id,
                                label:
                                  language === "ar"
                                    ? out_item?.name
                                    : out_item?.name_en,
                              };
                            })
                            ?.map((item, index) => {
                              return (
                                <MenuItem
                                  key={index}
                                  value={item?.id}
                                  onClick={() => {
                                    // const id = item?.id;
                                    // setlocdata({
                                    //   ...locdata,
                                    //   city_name: item?.label,
                                    // });
                                  }}
                                >
                                  <span>{item?.label}</span>
                                </MenuItem>
                              );
                            })
                        : null}
                    </Select>
            </div>
          </div>
        ) : null}
        <div style={{ marginBottom: "40px" }}>
          <label htmlFor="district">
            {language === "ar" ? "الحي" : "District"}
          </label>
          <input
            onChange={(e) => {
              setallolddata({ ...allolddata, state: e.target.value });
            }}
            value={allolddata.state}
            type="text"
            placeholder={language === "ar" ? "الحي" : "District"}
            name="state"
          />
        </div>

        <div className="arelocdef" style={{ display: "flex" }}>
          <label htmlFor="is_default">
            {language === "ar"
              ? "هل هذا العنوان افتراضي"
              : "Is This Address default"}
          </label>
          <Toggle
            onChange={(e) => {
              setallolddata({
                ...allolddata,
                is_default: !allolddata.is_default,
              });
            }}
            checked={allolddata.is_default == 1 ? true : false}
            name="is_default"
          />
        </div>

        <EditMap
          setLocationName={setLocationName}
          locdata={{
            lat: parseFloat(allolddata?.late),
            lng: parseFloat(allolddata?.lang),
          }}
        />
        {locationName?.map_location &&
        locationName?.latlng?.lat &&
        locationName?.latlng?.lng ? (
          <div>
            <label htmlFor="district">
              {language === "ar" ? "عنوان الخريطة" : "Map Location"}
            </label>
            <p>
              {locationName?.map_location +
                "-" +
                locationName?.latlng?.lat +
                "-" +
                locationName?.latlng?.lng}
            </p>
          </div>
        ) : null}
        <button
          disabled={editLoading}
          className="add_btn"
          style={{
            background: "var(--main-color)",
            color: "white",
            padding: "15px",
            margin: "5px 0",
            width: "100%",
            fontSize: "18px",
            cursor:editLoading?'no-drop':'pointer',
            borderRadius: "6px",
          }}
        >
          {
            editLoading?(<Spinner/>):(
              <>
                {language == "ar" ? " تعديل العنوان" : "Edit Location"}{" "}
              </>
            )
          }
        </button>
      </form>
    </div>
        </>
      }
    />
  );
};

export default EditLocation;
